import { BaseTable } from "../../../components/table";
import { TableBody, TableCell, TableRow } from "@mui/material";
import { BaseTablePropsType } from "../../../types/container.type";
import { formatDate } from "../../../helpers/dateFormatter";

export const LoginTable: React.FC<BaseTablePropsType> = ({ rows }) => {
	const loginTableHeaders = ["Name", "Last Logged In", "Last Activity"];
	return (
		<BaseTable headers={loginTableHeaders}>
			<TableBody>
				{rows?.map((row, index) => {
					return (
						<TableRow key={index}>
							<TableCell>{`${row?.firstName} ${row?.lastName}`}</TableCell>
							<TableCell>{formatDate(row?.lastLoginAt, true)}</TableCell>
							<TableCell>{formatDate(row?.lastActivityAt, true)}</TableCell>
						</TableRow>
					);
				})}
			</TableBody>
		</BaseTable>
	);
};
